import React from 'react';
import { FieldError, FieldInfo } from '../../../../../../hybrid/wrappers';
import { t } from '../../../../../../common/components/T';
import DatePicker from '../DatePicker/DatePicker';
import { useWidgetTranslates } from '../../../../../../common/utils/utils';
import css from './FormDateTimeCalendar.module.scss';
import classnames from 'classnames';

const FormDateCalendar = (props) => {
    const { title, compStyle, attribute, componentConfigTime, variation, info, errors } = props;

    const transl = useWidgetTranslates('form');
    const fieldStyle = {
        ...props.compStyle,
        wrapper: { marginBottom: '0', ...props.compStyle?.fieldWrapper },
        info: { wrapper: { display: 'none' } },
        error: { wrapper: { display: 'none' } }
    };

    return (
        <div className={classnames(css.formGroup, compStyle?.wrapper || {})}>
            <div className={classnames(css.formDateTimeWrapper, compStyle?.fields)}>
                <div className={classnames(css.formDateTimeD, compStyle?.date)}>
                    <DatePicker {...props} compStyle={fieldStyle} variation={variation || 'separated_title'} />
                </div>
                <div className={classnames(css.formDateTimeT, compStyle?.time)}>
                    <DatePicker
                        {...props}
                        title={title?.time || variation ? title : false}
                        isTime={true}
                        compStyle={fieldStyle}
                        placeholder={null}
                        componentConfig={{
                            ...componentConfigTime,
                            ...{
                                timeCaption: t('FormDate-time', 'Время', 'widget', transl, 'form'),
                                id: `${attribute}_time`
                            }
                        }}
                    />
                </div>
            </div>
            {!!info && <FieldInfo compStyle={compStyle.info}>{info}</FieldInfo>}
            {errors && errors.length
                ? errors.map((err, idx) => (
                      <FieldError compStyle={compStyle.error} key={`${attribute}${idx}`}>
                          {err}
                      </FieldError>
                  ))
                : null}
        </div>
    );
};
export default FormDateCalendar;
